import { gql } from 'graphql-request';

export default gql`query($filter: FilterInput) {
    dimming(filter: $filter) {
        id
        name
        mn_label
        mn_label_socket_y
        mn_label_socket_z
        driver_option_id
    }
}`;